export default __webpack_public_path__ + "images/05cbcd5694f04d9d9f42eb9d2fe6fdde.png";